import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import {Dropdown, Message, Divider, Schema, Form, Button } from 'rsuite';
import Flickity from 'react-flickity-component'
import { NavLink, useParams, useNavigate } from 'react-router-dom';



function withParams(Component) {
    return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}



const DisCode = Schema.Model({
    discode: Schema.Types.StringType().isRequired('این فیلد الزامی است.'),
});


export class CartSub extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            item: 0,
            subs: null,
            loader_1: null,
            loader_2: null,
            discode_input: null,
            discode: null,
            getway: null,
        };
    }


    // ---------------- componentDidMount--------------------------
    componentDidMount = () => {


        Send('page/cart/sub', null, true).then((res) => {
            this.setState({ 
                subs: res.data.sub,
                item: res.data.sub[0] ?? null,
            });


        }).catch((err) => { });




    }





    // ---------------- discode--------------------------

    discode = () => {

        this.setState({ loader_1: true });

        let data = {
            code: this.state.discode_input.discode,
            iid: this.state.item.id,
            type: 'p',
        }


        Send('page/cart/discount', data, true).then((res) => {
            H1.notfy_success(res.message)
            this.setState({ discode: res.data.discount });
            this.setState({ loader_1: false });
        }).catch((err) => {
            this.setState({ loader_1: false });
        });

    }

    // ---------------- get_pay--------------------------

    get_pay = () => {


        let data = {
            discount: this.state.discode ? this.state.discode.code : false,
            iid: this.state.item.id,
            type: 'sub',
        }

        this.setState({ loader_2: true });

        Send('page/cart/payment/invoice', data, null).then((res) => {


            H1.notfy_loading(res.message)


            if(res.data.PayFree === true){

                
                this.props.navigation(res.data.redirect_ok);


            }
            else{

                this.setState({ getway: JSON.parse(res.data.getway) }, () => {

                    document.getElementById("GetwayForm").submit();
                });
                    
            }




        }).catch((err) => {
            this.setState({ loader_2: false });
        });





    }



    // ---------------- removeCart--------------------------

    selectSub = (item_index) => {

        this.setState({
            item: this.state.subs[item_index],
            discode: null,
        }, () => {

           // H1.ScrollToElement('#pay_sec')

        });




    }


    render() {

        H1.page_name("اشتراک");



        return !this.state.subs ? null : (


            <div className="h-100 mt-4">


                {this.state.getway &&

                    <div className="d-none">
                        <form id="GetwayForm" action={this.state.getway.action} method={this.state.getway.method}>
                            {Object.keys(this.state.getway.inputs).map(key => (
                                <input type='hidden' name={key} value={this.state.getway.inputs[key]} />
                            ))}
                        </form>
                    </div>

                }



                <div className="c-row ">

                    <div className="text-center mb-4 fs-16">
                        خرید اشتراک
                    </div>

                    <p className='text-center mb-5'>اشتراک خود را انتخاب کنید و به  بیش از ۵۰ دوره ورزشی دسترسی داشته باشید.</p>




                    
                    <div className='sub_item bg-white br-32 mx-auto py-4 px-3' >


                        <div className="info p-2">
                            <div className="fs-12 fw-bold"> طلایی </div>
                            <div className="cc-1 mt-1 fs-36 text-nowrap"> {H1.formatNumber(this.state.item.price)}  <span className="fs-8 align-super"> تومان</span>  <span className='fs-14 cc-2'> / {this.state.item.type} ماهانه </span>   </div>
                            <ul className='p-0 dis-list none-list'>
                                <li className='mb-1'><span className="icon-Done ico"></span>  <div className='fs-12 d-inline-block'>دسترسی به کلاس های لایو</div>  </li>
                                <li className='mb-1'><span className="icon-Done ico"></span>  <div className='fs-12 d-inline-block'> مشاوره ورزشی</div>  </li>
                                <li className='mb-1'><span className="icon-Done ico"></span>  <div className='fs-12 d-inline-block'>پشتیبان </div>  </li>

                            </ul>
                        </div>


                        <Dropdown title={`${this.state.item.type} ماهه`}  className='drop_c text-start'>

                            {this.state.subs.map((item, index) => [
                                <Dropdown.Item key={index}  active={ this.state.item.id === item.id ? true : false } onSelect={() => this.selectSub(index)} >{item.type}  ماهه </Dropdown.Item>
                            ])}

                        </Dropdown>


                    </div>

{/* 

                    <Flickity
                        flickityRef={c => this.flkty = c}
                        className={'carousel mt-5'} // default ''
                        elementType={'div'} // default 'div'
                        options={{
                            initialIndex: 1,
                            prevNextButtons: false,
                            cellAlign: 'center',
                            rightToLeft: true
                        }} // takes flickity options {}
                        disableImagesLoaded={false} // default false
                        static // default false
                    >


                        {this.state.subs.map((item, index) => [


                        ])}



                    </Flickity> 



                    <Button appearance="primary" block className='fw-light btn_s1 mt-4 mx-auto' onClick={() => this.selectSub()}> انتخاب</Button>

*/}





                    {this.state.item &&
                        <>

                            <Divider className='my-3' id="pay_sec" />

                            <Form readOnly={this.state.discode ? true : false} model={DisCode} checkTrigger='none' noValidate={true} align="middle" onChange={(val) => this.setState({ discode_input: val })} onCheck={(e) => H1.isEmpty(e) && this.discode()}  >

                                <Form.Group controlId="discode" className='position-relative'>
                                    <Form.Control name="discode" type="text" className={`p-3 in_s1 ${this.state.discode ? 'cc-green' : ''}`} placeholder='کد تخفیف خود را وارد نمایید' />
                                    <Button disabled={this.state.discode ? true : false} className={`check_discode_btn ${this.state.discode ? 'en' : ''}`} appearance="subtle" type="submit" loading={this.state.loader_1}   ><span className="icon-Done ic"></span></Button>
                                </Form.Group>


                            </Form>




                            <div className="pay-box bg-white mt-3 p-3 br-16 d-flex flex-column">


                                <div className="p-row">  جمع کل   <span className='float-end fs-18'> {H1.formatNumber(this.state.item.price)}  <span className='fs-12 ms-1'> تومان  </span> </span>   </div>


                                <div className="p-row mt-2">   تخفیف   <span className='float-end fs-18 cc-red'>  {this.state.discode ? H1.formatNumber((this.state.discode.amount / 100) * this.state.item.price) : '0'}  <span className='fs-12 ms-1'> تومان  </span> </span>   </div>


                                <Divider className='my-3' />

                                <div className="p-row mt-2">   قابل پرداخت   <span className='float-end fs-3 cc-green'>  {this.state.discode ? H1.formatNumber(this.state.item.price - ((this.state.discode.amount / 100 * this.state.item.price))) : H1.formatNumber(this.state.item.price)}  <span className='ms-1'> تومان  </span> </span>   </div>


                            </div>


                            <Button appearance="primary" color="green" block className='fw-light btn_s1 mt-4 mx-auto' onClick={() => this.get_pay()} loading={this.state.loader_2}> پرداخت</Button>



                            <p className='fs-12 text-center mt-4'>لطفا هنگام ارجاع به درگاه پرداخت از خاموش بودن فیلترشکن خود اطمینان حاصل کنید.</p>



                        </>
                    }



                </div>



            </div>


        )
    }
}

export default withParams(CartSub);



